var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note"},[_c('div',{staticClass:"note__ico"},[_c('BaseSvg',{attrs:{"name":"ico-info"}})],1),_c('div',{staticClass:"note__text  text"},[_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.value))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }